import axios from 'axios';
import { 
  ReservarEntradaRequest, 
  ReservarEntradaResponse, 
  NominarEntradaRequest, 
  ReasignarEntradaRequest, 
  EntradaAfiliadoDto, 
  CertificadoAsistenciaDto,
  CongresoConfiguracionItemDto
} from '../types';

const API_URL = process.env.REACT_APP_API_URL || '';

const congresoService = {
  getCongresosActivos: async (): Promise<CongresoConfiguracionItemDto[]> => {
    try {
      const response = await axios.get(`${API_URL}/api/congresos/activos`);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  reservarEntrada: async (request: ReservarEntradaRequest): Promise<ReservarEntradaResponse> => {
    try {
      const response = await axios.post(`${API_URL}/api/entradas/reservar`, request);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  nominarEntrada: async (request: NominarEntradaRequest): Promise<{ exitoso: boolean; mensaje: string }> => {
    try {
      const response = await axios.post(`${API_URL}/api/entradas/nominar`, request);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  reasignarEntrada: async (request: ReasignarEntradaRequest): Promise<{ exitoso: boolean; mensaje: string }> => {
    try {
      const response = await axios.post(`${API_URL}/api/entradas/reasignar`, request);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  getMisEntradas: async (idAfiliado: number): Promise<EntradaAfiliadoDto[]> => {
    try {
      const response = await axios.get(`${API_URL}/api/congresos/entradas/mis-entradas?idAfiliado=${idAfiliado}`);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  getCertificado: async (idEntradaDetalle: number): Promise<CertificadoAsistenciaDto> => {
    try {
      const response = await axios.get(`${API_URL}/api/congresos/entradas/${idEntradaDetalle}/certificado`);
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  descargarTicketPdf: async (idEntradaDetalle: number, idAfiliado: number): Promise<Blob> => {
    try {
      const response = await axios.get(`${API_URL}/api/congresos/entradas/${idEntradaDetalle}/ticket-pdf?idAfiliado=${idAfiliado}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  descargarCertificadoPdf: async (idEntradaDetalle: number): Promise<Blob> => {
    try {
      const response = await axios.get(`${API_URL}/api/congresos/entradas/${idEntradaDetalle}/certificado`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  },

  obtenerQrCodeBlob: async (idEntradaDetalle: number, idAfiliado: number): Promise<Blob> => {
    try {
      const response = await axios.get(`${API_URL}/api/congresos/entradas/${idEntradaDetalle}/qr?idAfiliado=${idAfiliado}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error: any) {
      throw error.response ? error.response.data : new Error(error.message);
    }
  }
};

export default congresoService;
